"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
function default_1(base, rangeSelector) {
    var showRangeSelector = base.showRangeSelector, chartType = base.chartType;
    var defaultOptions = {
        enabled: showRangeSelector,
        showButtons: true,
        showDatePicker: true,
    };
    var options = __assign({}, defaultOptions);
    if (chartType === 'gantt') {
        options.enabled = false;
    }
    if (rangeSelector) {
        var overrides = __rest(rangeSelector.props, []);
        options = __assign(__assign({}, options), overrides);
    }
    return options;
}
exports.default = default_1;
//# sourceMappingURL=rangeSelectorOptions.js.map